import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import i18n from "i18n";
const LOOKUP_OPTIONS = { keySeparator: false, nsSeparator: false };
const SERVER_TEXT_NAMESPACES = [
  "server_fields",
  "enterprise_server_fields",
  "entity_attributes",
  "enterprise_entity_attributes"
];
const lookup = (translate, exists) => (namespaces, text) => {
  if (!text) {
    return text;
  }
  const namespace = namespaces.find((ns) => exists(text, { ns, ...LOOKUP_OPTIONS }));
  return namespace ? translate(text, { ns: namespace, ...LOOKUP_OPTIONS }) : text;
};
export const translateServerText = (text, namespaces = SERVER_TEXT_NAMESPACES) => lookup(
  (key, options) => i18n.t(key, options),
  (key, options) => i18n.exists(key, options)
)(namespaces, text);
const useServerText = (namespaces = SERVER_TEXT_NAMESPACES) => {
  const { t, i18n: instance } = useTranslation(namespaces);
  return useCallback(
    (text) => lookup(
      (key, options) => t(key, options),
      (key, options) => instance.exists(key, options)
    )(namespaces, text),
    // `t` changes with the language, which makes the components using this hook render again
    [t, instance, namespaces]
  );
};
export default useServerText;
